module.exports = __webpack_public_path__ + "static/media/ov-mockup.c865537c.png";